export default __webpack_public_path__ + "static/safe-with-papers-2c8ee1518897d9f5070fe7664bea7ebf.svg";